import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-customization-list',
  templateUrl: './customization-list.component.html',
  styleUrls: ['./customization-list.component.scss']
})
export class CustomizationListComponent implements OnInit, OnDestroy {
  constructor(private titleService: Title, private translateService: TranslateService, private router: Router) {}

  public ngOnInit(): void {
    this.titleService.setTitle(this.translateService.instant('roleplay.label'));
  }

  public ngOnDestroy(): void {}

  public viewCustomizationRoleplay(event: any): void {
    this.router.navigate(['/roleplays', event.detail.customizationId]).then();
  }
}
